var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "trbo-a-question-avatar" }, [
    _c("img", {
      staticClass: "trbo-a-question-avatar__image",
      attrs: { src: _vm.imageUrl, alt: "avatar" },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "trbo-a-question-avatar__name" }, [
      _vm._v("\n    " + _vm._s(_vm.name) + "\n  "),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }